import { useEffect, useRef, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import './IntroScreen.css';

const ASSET_BASE = 'https://api.getlayers.ai/storage/v1/object/public/public/assets/loopstack-f8c64439bf';

const IntroScreen = ({ onEnter }) => {
  const [leaving, setLeaving] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Try to force-play in case autoplay is throttled
    const v = videoRef.current;
    if (v) {
      const tryPlay = () => v.play().catch(() => {});
      tryPlay();
      const t = setTimeout(tryPlay, 500);
      return () => clearTimeout(t);
    }
  }, []);

  const handleEnter = () => {
    if (leaving) return;
    setLeaving(true);
    // Match CSS exit animation duration
    setTimeout(() => {
      onEnter?.();
    }, 900);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleEnter();
    }
  };

  return (
    <div
      className={`intro-screen${leaving ? ' leaving' : ''}`}
      onClick={handleEnter}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Cliquez pour entrer sur le site"
    >
      <div className="intro-video-wrap">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="intro-video"
        >
          <source src={`${ASSET_BASE}/flower.mp4`} type="video/mp4" />
        </video>
        <div className="intro-vignette" />
      </div>

      <div className="intro-content">
        <span className="intro-brand">
          webdream<span className="intro-brand-dot">.fr</span>
        </span>

        <h1 className="intro-title">
          <span className="intro-title-line">Des sites web pour</span>
          <span className="intro-title-line italic">les entreprises</span>
        </h1>

        <div className="intro-cta">
          <span className="intro-dot" />
          <span className="intro-cta-text">Cliquez pour entrer</span>
          <ArrowRight size={18} strokeWidth={1.8} />
        </div>

        <div className="intro-hint">appuyez n'importe où sur l'écran</div>
      </div>

      <div className="intro-corner top-left">WEBDREAM.FR · 2026</div>
      <div className="intro-corner top-right">by Nolan Longchamps</div>
      <div className="intro-corner bottom-left">Créé avec passion</div>
      <div className="intro-corner bottom-right">nolanlq@icloud.com</div>
    </div>
  );
};

export default IntroScreen;
